import React, { useEffect, useState } from "react";
import Select from "react-select";
import SelectedAttributeValues from "./SelectedAttributeValues";
import BulkVariantMeta from "./BulkVariantMeta";
import ReUse from "../../services/helpers/reUse";
import { key } from "../../Constant/Index";
import { useDispatch, useSelector } from "react-redux";
import { ProductsFilterActions } from "../../redux/slices/productsFilter.slice";

const BulkVariant = ({ inventoryVariantProps }) => {
  const {
    bulkVariantData,
    bulkVariantDataHandler,
    bulkVariantMOQs,
    variantMOQsHandler,
    extractAttributeOptions,
    setSelectedAttributes,
    selectedAttributes,
    attributeOptions,
    delimiters,
    handleAttributeOptionDelete,
    handleAttributeOptionAddition,
    handleAttributeOptionDrag,
    handleAttributeOptionClick,
    generatedVariations,
    bulkVariantAddFieldsData,
    setBulkVariantAddFieldsData,
    handlecolorsOptionAddition,
    colorssdsd,
    setAllCode,
    setMinimoq,
    setMaximoq,
    setPrice,
    minimoq,
    maximoq,
    price,
    setMetaData
    // meta,
    // setMeta,
  } = inventoryVariantProps ?? {};
  // console.log("generatedVariations",meta);

  const generateId = ReUse.makeId();

  const [meta,setMeta] = useState([]);

  const dispatch = useDispatch();

  const onChangeMetaRowHandler = (e,slug,index) => {
    const {name , value} = e.target;
    setMeta((preVal)=>{
      let newData = [...preVal?.map((val,index)=>{
        if(val?.slug === slug){
          return {
            ...val,
            rows : [
              ...val?.rows?.map((row,rowIndex)=>{
                if(rowIndex === index){
                  return {...row , [name] : value}
                }else { 
                  return row;
                }
              })
            ]
          }
        }else{
          return val
        }
      })];
      return newData
    });
    // if(meta?.length > 0){
    //   // localStorage.setItem("meta", JSON.stringify(meta) );
    //   // dispatch(ProductsFilterActions.setMeta(meta));
    // }
  }

  const onChangeMetaHandler = (e,slug) => {
    const {name , value} = e.target;
    setMeta((preVal)=>{
      let newData = [...preVal?.map((val,index)=>{
        if(val?.slug === slug){
          return {
            ...val,
            [name] : value
          }
        }else{
          return val
        }
      })];
      return newData
    });
    // if(meta?.length > 0){
    //   // localStorage.setItem("meta", JSON.stringify(meta) );
    //   // dispatch(ProductsFilterActions.setMeta(meta));
    // }
  }
  const onAddRowMetaHandler = (e,slug) => {
    setMeta((preVal)=>{
      let newData = [...preVal?.map((val,index)=>{
        if(val?.slug === slug){
          let newRows = [...val?.rows];
          (newRows?.length < 4) && newRows.push({
            maxQty : 0,
            minQty : 1,
            price : 0
          });
          return {
            ...val,
            rows : [...newRows]
          }
        }else{
          return val
        }
      })];
      return newData
    });
    // if(meta?.length > 0){
    //   // localStorage.setItem("meta", JSON.stringify(meta) );
    //   // dispatch(ProductsFilterActions.setMeta(meta));
    // }
  }

  console.log("meta",meta);
  useEffect(()=>{
    setMeta((preVal) =>{
      return generatedVariations?.map((val,index)=> {
      let metaFind = preVal?.find((val)=>val?.slug === val[`variation${index+1}`]);
        return (metaFind)? {...metaFind} : {
          slug : val[`variation${index+1}`],
          qty : 1,
          sku : '',
          rows : [{
            maxQty : 0,
            minQty : 1,
            price : 0
          }]
        }
      })
    })
    // if(meta?.length > 0){
    //   // console.log("meta st", meta)
    //   // localStorage.setItem("meta", JSON.stringify(meta) );
    //   // dispatch(ProductsFilterActions.setMeta(meta));
    // }
  },[generatedVariations])

  // useEffect(()=>{
  //   if(meta?.length > 0) {
  //     setTimeout(() => {
        
  //     }, 2000);
  //   dispatch(ProductsFilterActions.setMeta(meta));
  //   }
  //   // ProductsFilterActions.(meta);
  // },[])
  
  return (
    <>
      <div className="col-md-12">
        <div className="all-select-dv">
          <div className="mcq-dv-all">
            <h5>Add Varaitions / Attribute</h5>
          </div>

          <Select
            isMulti
            name="colors"
            options={extractAttributeOptions}
            classNamePrefix="select"
            onChange={(selectedOptions) =>{
              console.log("Selecting Attribute",selectedOptions);
              setSelectedAttributes(selectedOptions);
            }}
            // value={extractAttributeOptions?.find(
            // 	(option) => option?.value === selectedAttributes?.value,
            // )}
            value={selectedAttributes}
          />
        </div>
      </div>

      {selectedAttributes?.map((selectedAttribute, index) => (
        <SelectedAttributeValues
          attributeOptions={attributeOptions}
          delimiters={delimiters}
          handleAttributeOptionDelete={handleAttributeOptionDelete}
          handleAttributeOptionAddition={handleAttributeOptionAddition}
          handleAttributeOptionDrag={handleAttributeOptionDrag}
          handleAttributeOptionClick={handleAttributeOptionClick}
          selectedAttribute={selectedAttribute}
          currentIndex={index || 0}
          key={selectedAttribute?.value || index}
          l
          labelValue={selectedAttribute?.label}
          colorssdsd={colorssdsd}
          setAllCode={setAllCode}
          setMySelectedColors={inventoryVariantProps?.setMySelectedColors}
        />
      ))}

      {ReUse.generateVariants(inventoryVariantProps?.selectedAttributeValues)?.map((variation, index) => {

        let moq = inventoryVariantProps?.moqValues?.find((val)=>val?.slug === variation.toLowerCase());
        return (
          // <BulkVariantMeta
          //   key={generateId}
          //   variation={variation}
          //   index={index}
          //   bulkVariantDataHandler={bulkVariantDataHandler}
          //   bulkVariantData={bulkVariantData}
          //   variantMOQsHandler={variantMOQsHandler}
          //   bulkVariantAddFieldsData={bulkVariantAddFieldsData}
          //   setBulkVariantAddFieldsData={setBulkVariantAddFieldsData}
          //   setMinimoq={setMinimoq}
          //   setMaximoq={setMaximoq}
          //   setPrice={setPrice}
          //   minimoq={minimoq}
          //   maximoq={maximoq}
          //   price={price}
          // />
          <React.Fragment key={index}>
            {
              moq &&
              <div className="col-md-12 mt-2">
              <div className="row checkbox-border">
                <div className="show-all-dv">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="all-name-and-things">
                        <h3>Variant: {variation}</h3>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="check-quantity label-in-adding-prdoct">
                        <label>qty</label>
                        <input
                          type="number"
                          name="qty"
                          onChange={(e) =>inventoryVariantProps?.onChangeMoqHandler(e, variation.toLowerCase())}
                          value={moq?.qty || 1}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="check-quantity label-in-adding-prdoct">
                        <label>SKU</label>
                        <input
                          type="text"
                          name="sku"
                          placeholder="Sku"
                          onChange={(e) =>inventoryVariantProps?.onChangeMoqHandler(e, variation.toLowerCase())}
                          value={moq?.sku || ''}
                        />
                      </div>
                    </div>
                    {
                      moq?.rows?.map((row , rowIndex)=>(
                        <React.Fragment key={rowIndex}>
                          <div className="col-md-6">
                            <div className="check-quantity label-in-adding-prdoct">
                              <label>Minimoq</label>
                              <input
                                type="text"
                                name="minQty"
                                placeholder="Minimummoq"
                                onChange={(e) =>inventoryVariantProps?.onChangeMoqRowHandler(e, variation?.toLowerCase(),rowIndex)}
                                value={row?.minQty}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="check-quantity label-in-adding-prdoct">
                              <label>Maximoq</label>
                              <input
                                type="text"
                                name="maxQty"
                                placeholder="Maximummoq"
                                onChange={(e) =>inventoryVariantProps?.onChangeMoqRowHandler(e, variation?.toLowerCase(),rowIndex)}
                                value={row?.maxQty}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="check-quantity label-in-adding-prdoct">
                              <label>Price</label>
                              <input
                                type="text"
                                name="price"
                                placeholder="Price"
                                onChange={(e) =>inventoryVariantProps?.onChangeMoqRowHandler(e, variation?.toLowerCase(),rowIndex)}
                                value={row?.price}
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      ))
                    }
                    {
                      variation?.rows?.length < 4 &&
                      <button type="button" onClick={(e)=>inventoryVariantProps?.onAddRowMoqHandler(e,variation?.toLowerCase())}>
                        Add Rows
                      </button>
                    }
                  </div>

                  </div>
                </div>
              </div>
            }
          </React.Fragment>
        );
      })}
    </>
  );
};

export default BulkVariant;
